import React from 'react';
import moment from "moment";
import PropTypes from 'prop-types';
import { CustomDatePicker, DateWrapper, MobDatePicker } from "./styles";
import { DisplayFlex } from "../../../../CommonComponents/commonStyles";
//import { render } from 'enzyme';

export const onChange = (value, dateString, toTimeFrame) => {
  toTimeFrame({ value, dateString });
}

export const onStartDate = (value, dateString, startDate) => {
  startDate(value, dateString);
}

export const onEndDate = (value, dateString, endDate) => {
  endDate(value, dateString);
}

const disabledEndDate = (current) => {
  // Can not select days before today and today
  return current && current > moment().endOf('day');
}


const DateSelectorComponent = ({ toTimeFrame, startDate, endDate, open }) => {
  
  return (
    <DateWrapper id="datedate" data-test="document-centre-date-selector">
      {window.screen.availWidth < 576 ?
        <DisplayFlex style={{ flexDirection: "column" }}>
          <MobDatePicker
            format="DD/MM/YYYY"
            getCalendarContainer={() => document.getElementById("datedate")}
            onChange={(value, dateString)=>onStartDate(value, dateString, startDate)} />
          <MobDatePicker data-test='date-picker'
            className="asdfghj"
            format="DD/MM/YYYY"
            onChange={(value, dateString)=>onEndDate(value, dateString, endDate)}
            disabledDate={disabledEndDate}
            getCalendarContainer={() => document.getElementById("datedate")}
          />
        </DisplayFlex>
        :
        <CustomDatePicker
          format="DD/MM/YYYY"
          getCalendarContainer={() => document.getElementById("datedate")}
          placeholder={["Start Date", "End Date"]}
          disabledDate={disabledEndDate}
          open={open}
          onChange={(value, dateString) => onChange(value, dateString, toTimeFrame)}
        />
      }
    </DateWrapper>
  );
}

DateSelectorComponent.propTypes = {
  endDate: PropTypes.func.isRequired,
  startDate: PropTypes.func.isRequired,
  toTimeFrame: PropTypes.func.isRequired,
  open: PropTypes.bool
}

export default DateSelectorComponent;
